<div class="languages-mobile d-block d-sm-none">
    <span class="language-menu">{{activeLanguageName()}}</span>
</div>
